import CSS from 'csstype';
import styles from './childProfile.module.scss';
import IconRemove from '../../assets/icons/remove.svg?react';
import { Children } from '../../types';

type Props = {
  id: number;
  child: Children | undefined;
  color: CSS.Properties;
  onRemove: (index: number) => void;
};

function InviteChildrens(props: Props) {
  const { id, child, color, onRemove } = props;

  const handleRemoveChild = () => {
    onRemove(id);
};

  return (
    <div className={styles.itemWrapper}>
      <div className={styles.listItem} style={color}>
        <div className={styles.childTitle}>
          {child?.firstName.substring(0, 2) || '?'}
        </div>
        <div className={styles.removeItem} onClick={handleRemoveChild}>
          <IconRemove/>
        </div>
      </div>
      <div className={styles.childName}>
        {child?.firstName || ''}
      </div>
      <div className={styles.childNumber}>
        {child?.id || ''}
      </div>
    </div>
  )
}

export default InviteChildrens;
